import Modal from './Modal.tsx';

export default Modal;